import { styled } from "@mui/material/styles";
import { Close } from "@mui/icons-material";
import { IconButton } from "@mui/material";

import { colors } from "@zapalacorp/tokens";
import { Button } from "Components/Form";

export const LogicQuestionsSection = styled("section")(() => ({
  width: "100%",
  backgroundColor: "#FFFFFF",
}));

export const AddTriggerButton = styled(Button)(() => ({
  whiteSpace: "nowrap",
}));

export const BlankText = styled("span")(() => ({
  color: colors.brandBlue700,
}));

export const CloseIcon = styled(Close, {
  shouldForwardProp(propName) {
    return propName !== "disabled";
  },
})(({ disabled }: { disabled: boolean }) => ({
  cursor: disabled ? "default" : "pointer",
}));

export const EvidencesChip = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  borderRadius: "100px",
  background: colors.purple50,
  gap: "4px",
  padding: "4px 8px",

  fontFamily: "Manrope",
  fontSize: "12px",
  fontWeight: 600,
  lineHeight: "16px",
  letterSpacing: "0.5px",
  color: colors.purple600,
}));

export const LogicActionsWrapper = styled("div")(() => ({
  display: "flex",
  padding: "12px",
  flexDirection: "row",
  alignItems: "center",
  gap: "12px",
  backgroundColor: colors.gray200,
}));

export const LogicContains = styled("div")(() => ({
  width: "100%",
  maxWidth: "200px",
}));

export const LogicSelection = styled("div")(() => ({
  width: "100%",
  maxWidth: "130px",
}));

export const QuestionsChip = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  borderRadius: "100px",
  background: colors.blue50,
  gap: "4px",
  padding: "4px 8px",

  fontFamily: "Manrope",
  fontSize: "12px",
  fontWeight: 600,
  lineHeight: "16px",
  letterSpacing: "0.5px",
  color: colors.blue600,
}));

export const RemoveLogicButton = styled(IconButton)(() => ({
  borderRadius: "8px",
  border: `1px solid ${colors.error500}`,
  color: colors.error500,
  height: "40px",
  width: "40px",

  "&:focus": {
    border: `1px solid ${colors.error500}`,
  },

  "&:disabled": {
    color: colors.gray300,
    border: `1px solid ${colors.gray300}`,
  },
}));
